import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { AbstractFetchAdaptor } from '../../../common/fetch/abstract-fetch.adaptor';
import { API_BASE_URL } from '../../../core/interceptors/base-path.interceptor';

interface TncResponse {
  data: TncData;
}

interface TncData {
  id: number;
  json_attributes: TncEnAttributes;
}

interface TncEnAttributes {
  en_content: [
    {
      name: string;
      content: string;
      link: string;
    },
  ];
}
type TncResponseMap = TncResponse['data']['json_attributes']['en_content'][0];

@Injectable({ providedIn: 'root' })
export class TncAdaptor extends AbstractFetchAdaptor<object, TncResponseMap> {
  override name = 'tnc';

  private http = inject(HttpClient);
  private apiBaseURL = inject(API_BASE_URL);
  private pdfUrlCache = new Map<string, string>();

  // For local development, override with localhost if needed
  constructor() {
    super();
  }

  tncLink(property: string = 'yss_terms_of_registering_file_link'): string {
    // Use cached URL if available
    if (this.pdfUrlCache.has(property)) {
      return this.pdfUrlCache.get(property)!;
    }
    // For viewing in browser
    const url = `${this.apiBaseURL}/accounts/${property}?pdf=true`;
    this.pdfUrlCache.set(property, url);

    return url;
  }

  override onRequest(props: object = {}): Observable<TncResponseMap> {
    const property = (props as any).property || 'yss_terms_of_registering_file_link';

    return this.http
      .get<TncResponse>(`${this.apiBaseURL}/accounts/${property}?pdf=false`)
      .pipe(map((res) => res.data.json_attributes.en_content[0]));
  }

  getPdf(property: string = 'yss_terms_of_registering_file_link'): Observable<HttpResponse<Blob>> {
    const url = `${this.apiBaseURL}/accounts/${property}`;

    return this.http.get(url, {
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/pdf',
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      }),
      observe: 'response',
    });
  }
}
